import { Box, Image, Link } from "components/base";
import { Container, ContainerFluid, Flex } from "components/base/container";
import { DiscordIcon, TelegramIcon, TwitterIcon } from "components/icon/icon.normal";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useWallet } from "@manahippo/aptos-wallet-adapter";
import { FAUCET_URL, MODULE_ADDR, NODE_URL } from "config";
import { PoolInfo } from "utils/types";
import { TokenId, WalletClient } from "@martiandao/aptos-web3-bip44.js";
import styled from "styled-components";
import { NormalBtn } from "components/element/element.button";
import Loading from "components/element/element.loading";

interface StakeInfo{
  claimed_time: string,
  staked_time: string,
  token_id: TokenId
}
interface SimpleMap{
  key: string,
  value: StakeInfo[]
}
interface StakeTokenData{
  pool_id_list: string[],
  stake_infos: {
    data: SimpleMap[]
  }
}

interface TokenData {
  data: TokenId;
  deposit_sequence_number: string;
  withdraw_sequence_number: string;
  difference: number;
}
interface TokenIds {
  tokenIds: TokenData[];
  maxDepositSequenceNumber: number;
  maxWithdrawSequenceNumber: number;
}
interface TokenURI {
  collection: string;
  name: string;
  description: string;
  uri: string;
  supply: string;
}
interface TokenIdExtra extends TokenId {
  rewards: string;
  token_uri: TokenURI;
  url: string;
}

const DetailPage = () => {
  const { connected, account, signAndSubmitTransaction } = useWallet();
  const { pool_id } = useParams<{ pool_id: string }>();
  const [poolInfo, setPoolInfo] = useState<PoolInfo>(null);
  const [unstakedTokenList, setUnstakedTokenList] = useState<TokenIdExtra[]>([]);
  const [stakedTokenList, setStakedTokenList] = useState<TokenIdExtra[]>([]);
  const [loadingStaked, setLoadingStaked] = useState(false);
  const [loadingUnstaked, setLoadingUnstaked] = useState(false);
  const [change, SetChange] = useState<boolean>(true);
  const [apis] = useState(new WalletClient(NODE_URL, FAUCET_URL));

  useEffect(() => {
    getPoolInfo();
  }, [change, apis]);

  useEffect(() => {
    getStakedList();
    getUnstakedList();
  }, [change, poolInfo, apis]);

  const getPoolInfo = async () => {
    // let resource = await apis.getAccountResource(MODULE_ADDR, `${MODULE_ADDR}::snore::SnorePoolList`);
    // if (!resource) return;
    // const snore_pool_list = resource?.data as SnorePoolList;
    try {
      let pool_info: PoolInfo = await apis.getCustomResource(
        MODULE_ADDR,
        `${MODULE_ADDR}::snore::SnorePoolList`,
        "pool_table",
        "u64",
        `${MODULE_ADDR}::snore::SnorePool`,
        pool_id
      );
      setPoolInfo(pool_info);
    } catch (err) {
      console.log(err);
    }
  };

  const getStakedList = async () => {
    if (!connected) return;
    if (!poolInfo) return;
    try {
      setLoadingStaked(true);
      const collection_creator = poolInfo.collection_creator;
      const collection_name = poolInfo.collection_name;

      let res_stake = await apis.getAccountResource(account?.address as string, `${MODULE_ADDR}::snore::SnoreStake`);      
      if (!res_stake) {
        setStakedTokenList([]);
        setLoadingStaked(false);
        return;
      }
      const res_data = res_stake?.data as StakeTokenData;
      let stake_infos = res_data.stake_infos.data.find(item => parseInt(item.key) == parseInt(pool_id) );

      if (!stake_infos || stake_infos.value.length == 0){
        setStakedTokenList([]);
        setLoadingStaked(false);
        return;
      }
      let temp_token_ids: TokenIdExtra[] = [];
      let ledgerInfo = await apis.aptosClient.getLedgerInfo();
      let now = parseInt(ledgerInfo.ledger_timestamp) / 1000000; // now seconds
      for (let i = 0; i<stake_infos.value.length; i++) {
           let tokenId = stake_infos.value[i].token_id;       
           let temp_token_id:TokenIdExtra = tokenId as TokenIdExtra;
           let interval = 0;
           if ( parseInt(stake_infos.value[i].staked_time) + parseInt(poolInfo.staking_duration) < now ){
             interval = parseInt(stake_infos.value[i].staked_time) + parseInt(poolInfo.staking_duration) - parseInt(stake_infos.value[i].claimed_time);
           }else{
             interval = now - parseInt(stake_infos.value[i].claimed_time);
           }
           temp_token_id.rewards = (interval * parseInt(poolInfo.reward_per_day) / 86400).toFixed(3);
           temp_token_id.token_uri = await apis.getToken(tokenId);
           const r = await fetch(temp_token_id.token_uri.uri);
          const jsonR = await r.json();
          temp_token_id.url = jsonR.image;
           temp_token_ids.push(temp_token_id);
	   
      }   
       
      setLoadingStaked(false);
      setStakedTokenList(temp_token_ids);
    } catch (error) {
      console.log(`No exist for pool_id ${pool_id} `);
      return;
    }
  };

  const getUnstakedList = async () => {
    if (!connected) return;
    if (!poolInfo) return;

    setLoadingUnstaked(true);
    let tokenIds: TokenIds = await apis.getTokenIds(account?.address as string);

    if (!tokenIds || tokenIds.tokenIds.length === 0) {
      setUnstakedTokenList([]);
      setLoadingUnstaked(false);
      return;
    }
    let token_ids: TokenData[] = tokenIds.tokenIds;
    let result_tokens: TokenIdExtra[] = [];
    const collection_creator = poolInfo.collection_creator;
    const collection_name = poolInfo.collection_name;

    for (let i = 0; i < token_ids.length; i++) {
      let token_id = token_ids[i];
      if (token_id.difference !== 1) continue;
      if (token_id.data.token_data_id.creator === collection_creator && token_id.data.token_data_id.collection === collection_name) {
        let temp_token: TokenIdExtra = token_id.data as TokenIdExtra;
        temp_token.token_uri = await apis.getToken(temp_token);
        const r = await fetch(temp_token.token_uri.uri);
        const jsonR = await r.json();
        temp_token.url = jsonR.image;
        result_tokens.push(temp_token);
      }
    }
    setLoadingUnstaked(false);
    setUnstakedTokenList(result_tokens);
  };

  const claim = async () => {
    if (!connected) return;
    let transaction = {
      type: "entry_function_payload",
      function: `${MODULE_ADDR}::snore::claim`,
      arguments: [pool_id],
      type_arguments: [poolInfo.reward_coin_name],
    };
    try {
      const result = await signAndSubmitTransaction(transaction);
      console.log(result.hash);
      SetChange(!change);
    } catch (error) {
      console.log(error);
    }
  };
  const unstake = async (token_name: string, version: string) => {
    if (!connected) return;
    let transaction;
    const v = parseInt(version);
    if (v != 0) {
      transaction = {
        type: "entry_function_payload",
        function: `${MODULE_ADDR}::snore::unstakeV`,
        arguments: [pool_id, token_name, v],
        type_arguments: [poolInfo.reward_coin_name],
      };
    } else {
      transaction = {
        type: "entry_function_payload",
        function: `${MODULE_ADDR}::snore::unstake`,
        arguments: [pool_id, token_name],
        type_arguments: [poolInfo.reward_coin_name],
      };
    }

    try {
      const result = await signAndSubmitTransaction(transaction);
      console.log(result.hash);
      SetChange(!change);
    } catch (error) {
      console.log(error);
    }
  };
  const stake = async (token_name: string, version: string) => {
    if (!connected) return;
    let transaction;
    const v = parseInt(version);
    if (v != 0) {
      transaction = {
        type: "entry_function_payload",
        function: `${MODULE_ADDR}::snore::stakeV`,
        arguments: [pool_id, token_name, v],
        type_arguments: [poolInfo.reward_coin_name],
      };
    } else {
      transaction = {
        type: "entry_function_payload",
        function: `${MODULE_ADDR}::snore::stake`,
        arguments: [pool_id, token_name],
        type_arguments: [poolInfo.reward_coin_name],
      };
    }
    try {
      const result = await signAndSubmitTransaction(transaction);
      console.log(result.hash);
      SetChange(!change);
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <ContainerFluid>
      <Flex
        background={`url(${require("assets/image/detail/back.png")})`}
        backgroundPosition={"center"}
        backgroundSize={"cover"}
        width={"100%"}
        height={"220px"}
        overflow={"hidden"}
      />
      <Container pb={["20px", "20px", "40px"]} col>
        <Flex
          flexDirection={["column", "column", "row"]}
          gridGap={"38px"}
          mt={"-150px"}
          bg={"normal"}
          width={"100%"}
          p={["25px 21px", "25px 21px", "32px 31px", "40px 42px"]}
          borderRadius={"24px"}
        >
          {!poolInfo ? (
            <Loading mx={"auto"} my={"20px"} loading={true} noText />
          ) : (
            <>
              <Flex flex={"3"} col alignCenter gridGap={"20px"}>
                <Image borderRadius={"24px"} width={"100%"} src={poolInfo?.collection_img_url} />
                <Flex fontSize={["24px", "26px", "28px", "30px"]} color={"light"} gridGap={["12px", "12px", "20px"]}>
                  {poolInfo?.twitter_url && (
                    <Link target={"_blank"} href={poolInfo?.twitter_url}>
                      <TwitterIcon />
                    </Link>
                  )}
                  {poolInfo?.discord_url && (
                    <Link target={"_blank"} href={poolInfo?.discord_url}>
                      <DiscordIcon />
                    </Link>
                  )}
                  {poolInfo?.telegram_url && (
                    <Link target={"_blank"} href={poolInfo?.telegram_url}>
                      <TelegramIcon />
                    </Link>
                  )}
                </Flex>
              </Flex>
              <Flex flex={"7"} col gridGap={"24px"}>
                <Flex color={"white"} fontWeight={"700"} fontSize={"48px"} lineHeight={"100%"}>
                  {poolInfo?.collection_name}
                </Flex>
                <Flex fontWeight={"400"} fontSize={"22px"} lineHeight={"130%"}>
                  {poolInfo?.collection_desc}
                </Flex>
                <Flex my={"auto"} flexDirection={["column", "column", "row"]} justifyContent={"center"} gridGap={"16px"}>
                  <Flex flex={"1"} col gridGap={"16px"} p={"16px"} borderRadius={"16px"} boxShadow={"2px 2px 10px 0px #0005"}>
                    <Flex>Stake Limit</Flex>
                    <Flex fontSize={"1.5em"} fontWeight={"600"}>
                      { poolInfo.nft_total_count }
                    </Flex>
                  </Flex>
                  <Flex flex={"1"} col gridGap={"16px"} p={"16px"} borderRadius={"16px"} boxShadow={"2px 2px 10px 0px #0005"}>
                    <Flex>Staked NFT</Flex>
                    <Flex fontSize={"1.5em"} fontWeight={"600"}>
                      { poolInfo.staking_amount }
                    </Flex>
                  </Flex>
                  <Flex flex={"1"} col gridGap={"16px"} p={"16px"} borderRadius={"16px"} boxShadow={"2px 2px 10px 0px #0005"}>
                    <Flex>Reward Pool</Flex>
                    <Flex fontSize={"1.5em"} fontWeight={"600"}>
                      { (parseInt(poolInfo.deposit_coin_amount) / 100000000) } APT
                    </Flex>
                  </Flex>
                </Flex>
              </Flex>
            </>
          )}
        </Flex>
      </Container>
      <Container col gridGap={"24px"} pb={"24px"} minHeight={"50vh"}>
        {connected ? (
          <>
            <Flex p={"10px"} fontSize={"1.4em"} fontWeight={"bold"} lineHeight={"1em"} borderBottom={"2px solid"} borderBottomColor={"normal"}>
              Your staked NFTs
            </Flex>
            <Loading mx={"auto"} my={"20px"} loading={loadingStaked} noText />
            <Box display={"grid"} gridGap={"24px"} justifyItems={"center"} gridTemplateColumns={["1fr", "1fr", "1fr 1fr", "1fr 1fr 1fr"]}>
              {stakedTokenList.map((token: TokenIdExtra, index) => {
                return <NftCard key={`staked-${index}`} isMyNFT token={token} actClaim={claim} actUnStake={unstake} />;
              })}
            </Box>
            <Flex p={"10px"} fontSize={"1.4em"} fontWeight={"bold"} lineHeight={"1em"} borderBottom={"2px solid"} borderBottomColor={"normal"}>
              NFTs in your wallet
            </Flex>
            <Loading mx={"auto"} my={"20px"} loading={loadingUnstaked} noText />
            <Box display={"grid"} gridGap={"24px"} justifyItems={"center"} gridTemplateColumns={["1fr", "1fr", "1fr 1fr", "1fr 1fr 1fr"]}>
              {unstakedTokenList.map((token: TokenIdExtra, index) => {
                return <NftCard key={`staked-${index}`} token={token} actStake={stake} />;
              })}
            </Box>
          </>
        ) : (
          <Flex justifyCenter fontSize={"1.7em"} fontWeight={"bold"} opacity={"0.7"} textAlign={"center"}>
            Please connect wallet to see NFTs
          </Flex>
        )}
      </Container>
    </ContainerFluid>
  );
};

interface NftCardProps {
  isMyNFT?: boolean;
  token: TokenIdExtra;
  actStake?: (arg: any, version: any) => void;
  actUnStake?: (arg: any, version: any) => void;
  actClaim?: () => void;
}
const NftCard: React.FC<NftCardProps> = ({ isMyNFT, token, actStake, actClaim, actUnStake }) => {
  return (
    <NftCardBase>
      <Image width={"100%"} src={token.url} />
      <Flex width={"100%"} gridGap={"5px"} marginTop={"10px"}>
        <Flex fontSize={"1.4em"} fontWeight={"bold"} lineHeight={"1em"}>
          {token.token_data_id.name}
        </Flex>
      </Flex>
      {isMyNFT && (
        <Flex width={"100%"} gridGap={"5px"} marginTop={"10px"}>
          <Flex fontSize={"1.4em"} fontWeight={"bold"} lineHeight={"1em"}>
            Rewards: {parseInt(token.rewards) / 100000000} APT
          </Flex>
        </Flex>
      )}
      <Flex width={"100%"} marginTop={"20px"} spaceBetween gridGap={"10px"}>
        {isMyNFT ? (
          <>
            <NormalBtn p={"10px 20px"} border={"none"} onClick={() => actClaim()}>
              Claim
            </NormalBtn>
            <NormalBtn p={"10px 20px"} background={"none"} onClick={() => actUnStake(token.token_data_id.name, token.property_version)}>
              UnStake
            </NormalBtn>
          </>
        ) : (
          <NormalBtn p={"10px 20px"} ml={"auto"} border={"none"} onClick={() => actStake(token.token_data_id.name, token.property_version)}>
            Stake
          </NormalBtn>
        )}
      </Flex>
    </NftCardBase>
  );
};

const NftCardBase = styled(Flex)``;
NftCardBase.defaultProps = {
  flexDirection: "column",
  alignItems: "center",
  bg: "normal",
  width: "100%",
  p: ["10px", "10px", "15px", "25px"],
  borderRadius: "16px",
  boxShadow: "2px 2px 10px 0px #0005",
};

export default DetailPage;
